import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconReceiptStorno: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconReceiptStorno"><Path d="M8.75 14.75H15.25M13.875 7.375L12 9.25M12 9.25L10.125 11.125M12 9.25L10.125 7.375M12 9.25L13.875 11.125M7.75 2.75H16.25C17.9069 2.75 19.25 4.09315 19.25 5.75V21.25L16.6667 19L14.3333 21.25L12 19L9.66667 21.25L7.33333 19L4.75 21.25V5.75C4.75 4.09315 6.09315 2.75 7.75 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconReceiptStorno;
